// The period selector shared by Feiloversikt and Endepunkter — both read the
// same `range` URL param, so they must offer the same choices.
import { type LogRange } from "@/hooks/api";
import { cn } from "@/lib/cn";

export const RANGES: LogRange[] = ["1h", "24h", "7d", "30d"];
export const RANGE_LABEL: Record<LogRange, string> = {
  "1h": "1 t",
  "24h": "24 t",
  "7d": "7 d",
  "30d": "30 d",
};

/** Anything the URL carries that isn't a known range falls back to 24h. */
export function parseRange(value: string | null): LogRange {
  return RANGES.includes(value as LogRange) ? (value as LogRange) : "24h";
}

export function RangePicker({
  value,
  onChange,
}: {
  value: LogRange;
  onChange: (r: LogRange) => void;
}) {
  return (
    <div className="flex border border-admin-card-border rounded-[7px] overflow-hidden text-xs">
      {RANGES.map((r) => (
        <button
          key={r}
          onClick={() => onChange(r)}
          className={cn(
            "px-3 py-1.5 cursor-pointer border-r border-admin-card-border last:border-r-0 transition-colors duration-[120ms]",
            value === r
              ? "bg-admin-card-hover text-admin-text-primary"
              : "text-admin-text-secondary hover:bg-admin-card-hover/40"
          )}
        >
          {RANGE_LABEL[r]}
        </button>
      ))}
    </div>
  );
}
